import { isNicheKink } from '../utils/kinkVisibility.js';

export const DATABASE_BROWSE_RESET_DEFAULTS = {
    searchQuery: '',
    selectedCategory: null,
    selectedIntensities: [],
    selectedLenses: [],
    showNiche: false,
    showArchive: false
};

export function isArchivedKink(item) {
    return isNicheKink(item);
}

export function deriveKinkBrowseSplitState({
    entityType,
    baseFilteredData,
    showNiche,
    showArchive,
    hasMore = false,
    initialPopularCount = null,
    allowPaginationSplit = false
}) {
    const explicitPopularData = entityType !== 'kinks'
        ? baseFilteredData
        : baseFilteredData.filter(item => !isArchivedKink(item));

    const explicitArchiveData = entityType !== 'kinks'
        ? []
        : baseFilteredData.filter(isArchivedKink);

    const canUsePaginationSplit = entityType === 'kinks'
        && allowPaginationSplit
        && explicitArchiveData.length === 0
        && Number.isInteger(initialPopularCount)
        && initialPopularCount > 0;

    const paginationPopularCount = canUsePaginationSplit
        ? Math.min(initialPopularCount, baseFilteredData.length)
        : null;

    const popularData = canUsePaginationSplit
        ? baseFilteredData.slice(0, paginationPopularCount)
        : explicitPopularData;

    const archiveData = canUsePaginationSplit
        ? baseFilteredData.slice(paginationPopularCount)
        : explicitArchiveData;

    const shouldSplitKinks = entityType === 'kinks'
        && !showNiche
        && popularData.length > 0
        && (archiveData.length > 0 || (canUsePaginationSplit && hasMore));

    const visibleData = shouldSplitKinks
        ? (showArchive ? baseFilteredData : popularData)
        : (showNiche ? baseFilteredData : popularData);

    return {
        popularData,
        archiveData,
        shouldSplitKinks,
        visibleData
    };
}
